<template>
    <v-container>
      <v-row>
        <v-col :cols="[this.$vuetify.breakpoint.smAndDown ? 12 : 6]">
          <v-img src="https://i.imgur.com/qYE8rS0.jpg" max-height="80vh" contain></v-img>
        </v-col>
        <v-col :cols="[this.$vuetify.breakpoint.smAndDown ? 12 : 6]">
          <div class="text-h2 mb-5">List of planed changes</div>
          <v-container
          id="scroll-target"
          style="max-height: 50vh"
          class="overflow-y-auto mt-3"
          >
          <v-expansion-panels accordion focusable>
              <v-expansion-panel
                v-for="(todo, i) in todos"
                :key="i"
              >
                <v-expansion-panel-header>{{todo.title}}</v-expansion-panel-header>
                <v-expansion-panel-content>
                  {{todo.desc}}
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-container>
        </v-col>
      </v-row>
    </v-container>
  </template>
  
  <script>
  
      export default {
        name: 'todo',
        data: () => ({
          todos:[
            {
              title: "Support Reroll",
              desc: "Currently, reroll functionality is not working. Rerolls must be performed by refreshing the page. This is sub-optimal"
            },
            {
              title: "Add Interactive Roulettes",
              desc: "Currently, all roulettes are very simple, interactive roulettes will be more engaging, dynamic, and unique"
            },
          ]
        }),
        methods: {

        },
      }
  </script>